import { render, staticRenderFns } from "./shipmentInspectionAdd.vue?vue&type=template&id=65eec317&scoped=true"
import script from "./shipmentInspectionAdd.vue?vue&type=script&lang=js"
export * from "./shipmentInspectionAdd.vue?vue&type=script&lang=js"
import style0 from "./shipmentInspectionAdd.vue?vue&type=style&index=0&id=65eec317&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eec317",
  null
  
)

export default component.exports